import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';
import { buildSkuSelectionFields, buildSkuSelectorScrollFields } from 'ai/analytics/utils/sotFields';
import { EVENT_NAMES } from 'ai/analytics/events';
import { getOrderedValidVariations } from 'ai/utils/skuSelectorUtils';
import { ensureFreshReferrer } from 'ai/analytics/utils/superChatAnalyticsContext';
import { getSuperChatReferrer } from 'ai/utils/sessionStorage';

let hasFiredSwatchClick = false;

const scrollCache = new Map();
let scrollSessionId = null;
let scrollReferrer = null;

export function trackSkuSwatchClick() {
    if (hasFiredSwatchClick) {
        return;
    }

    hasFiredSwatchClick = true;

    processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
        data: {
            pageName: anaConsts.SUPER_CHAT.SUPERCHAT_LANDING,
            actionInfo: anaConsts.SUPER_CHAT.SUPERCHAT_SKU_SWATCH
        }
    });
}

export function resetSkuSwatchClickCache() {
    hasFiredSwatchClick = false;
}

export function getSkuSelectorVariantType(product) {
    return getOrderedValidVariations(product?.variations)[0]?.variation_type || null;
}

export function cacheSkuSelectorScroll({
    productId, variantType, seen, total, sessionId
} = {}) {
    if (!productId || !seen || !total) {
        return;
    }

    if (sessionId && !scrollSessionId) {
        scrollSessionId = sessionId;
    }

    if (!scrollReferrer) {
        scrollReferrer = ensureFreshReferrer();
    }

    const entry = scrollCache.get(productId);

    if (!entry) {
        scrollCache.set(productId, {
            productId, variantType, seen, total
        });

        return;
    }

    entry.seen = Math.max(entry.seen, seen);
}

export function resetSkuSelectorScrollCache() {
    scrollCache.clear();
    scrollSessionId = null;
    scrollReferrer = null;
}

export function flushSkuSelectorScrollImpression() {
    if (scrollCache.size === 0) {
        return;
    }

    const eventName = EVENT_NAMES.SKU_SELECTOR_SCROLL_IMPRESSION;

    processEvent.process(anaConsts.SOT_LINK_TRACKING_EVENT, {
        data: {
            linkName: eventName,
            actionInfo: eventName,
            specificEventName: eventName,
            sotType: eventName,
            ...buildSkuSelectorScrollFields({
                sessionId: scrollSessionId,
                referrer: scrollReferrer,
                products: Array.from(scrollCache.values())
            })
        }
    });

    resetSkuSelectorScrollCache();
}

export function trackVariantSelection({
    product, skuId, previousSkuId, sessionId
}) {
    if (!product || !skuId || skuId === previousSkuId) {
        return;
    }

    trackSkuSwatchClick();

    const eventName = EVENT_NAMES.SKU_SELECTION;

    processEvent.process(anaConsts.SOT_LINK_TRACKING_EVENT, {
        data: {
            linkName: eventName,
            actionInfo: eventName,
            specificEventName: eventName,
            sotType: eventName,
            ...buildSkuSelectionFields({
                sessionId,
                productId: product.id,
                skuId,
                colorIqSkuId: product.pre_selected_sku_id,
                referrer: getSuperChatReferrer()
            })
        }
    });
}
